// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2bjCB","balanceDisclaimer":"posDashboard_balanceDisclaimer__1K0Km"};